import {Component, OnInit} from '@angular/core';
import {ThemeOptions} from '../../../../../theme-options';
import { AuthService } from '../../../../../Pages/authentication/auth.service'
import { ProfileService } from 'src/app/Portal/profile/profile.service';
@Component({
  selector: 'app-user-box',
  templateUrl: './user-box.component.html',
})
export class UserBoxComponent implements OnInit {

  type:any;
  ProfileData: any = {
    age: '',
    email: '',
    name: {
      first: '',
      last: ''
    },
    mobile_number: '',
    profile_image: ''

  };
  ProfileImage: any;
  constructor(public globals: ThemeOptions,
              private authService: AuthService,
              private profileService: ProfileService) {
  }

  ngOnInit() {
    console.log('scope in user-box',localStorage.getItem('scope'))
    this.type = localStorage.getItem('scope')
    console.log('scope in user-box type',this.type)

  }

  logout() {
    this.authService.logout();
   
  }
}
